<template>
  <VPanel class="p-6">
    <h1 class="text-lg">
      مدیریت اسلایدر
    </h1>
    <hr class="border-dark-line mt-6">

    <div class="grid grid-cols-4 mt-6 gap-10">
      <a href="#" @click.prevent="modalCreate = true"
         class="flex flex-col justify-center items-center border-2 border-accent border-dashed rounded-xl min-h-[20rem]">
        <PlusIcon/>
        <span class="text-accent">اسلایدر جدید</span>
      </a>

      <SliderCard
          v-for="(slider, index) in sliders"
          :key="slider.id"
          :slider="slider"
          @edited="sliderEdited($event, index)"
          @deleted="sliderDeleted(index)"/>

    </div>

    <ModalSlider
        :show="modalCreate"
        @click="modalCreate = !modalCreate"
        @created="sliderCreated"/>

  </VPanel>
</template>

<script>
import VPanel from "@/components/VPanel";
import PlusIcon from "@/components/Icons/PlusIcon";
import {getSliders} from "@/API/API";
import ModalSlider from "@/components/Modal/ModalSlider.vue";
import SliderCard from "@/components/Setting/SliderCard.vue";

export default {
  name: "SliderView",
  components: {SliderCard, ModalSlider, PlusIcon, VPanel},
  data() {
    return {
      sliders: [],
      modalCreate: false,
    }
  },
  async created() {
    this.sliders = (await getSliders()).data
  },
  methods: {
    sliderCreated(slider) {
      this.modalCreate = false
      this.sliders.unshift(slider)
    },
    sliderEdited(slider, index) {
      this.sliders[index] = slider
    },
    sliderDeleted(index) {
      this.sliders.splice(index, 1)
    }
  }
}
</script>

<style scoped>

</style>